class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.generateRecommendations();
    this.attachQuickAddListeners(); // Call method to attach quick add listeners
  }

  generateRecommendations() {
    const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
    if (cartItems.length > 0) {
      fetch(
        `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItems[0].dataset.productId}&limit=${this.dataset.limit}`
      )
        .then((response) => response.text())
        .then((text) => {
          const innerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-js-cart-recommendations-performed]');
          if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
            this.innerHTML = innerHTML.innerHTML;
            this.attachQuickAddListeners(); // Re-attach listeners after DOM is updated
          }
        })
        .catch((error) => console.error('Error fetching recommendations:', error));
    }
  }

  attachQuickAddListeners() {
    const quickAddButtons = this.querySelectorAll('.cart_quick_add'); // Use this.querySelector to find buttons within the shadow DOM of this element

    quickAddButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        const variantId = button.getAttribute('variant-id');

        // Check if variantId is valid
        if (!variantId) {
          console.error('Variant ID is missing');
          return;
        }

        const quantity = 1;
        const data = { id: variantId, quantity };

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          });

          if (response.ok) {
            const cart = await response.json();
            console.log('Cart updated:', cart);

            // Trigger event to update the cart counter
            document.dispatchEvent(
              new CustomEvent('Edition:cart:reload', {
                detail: { cart },
              })
            );

            // Call window.refreshCart to reload the cart UI
            if (window.refreshCart) {
              window.refreshCart();
            }
          } else {
            console.error('Error updating cart:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      });
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
